import { lazyLoad } from 'utils/loadable';

export const JoinAdGroupPage = lazyLoad(
  () => import('./index'),
  module => module.JoinAdGroupPage,
);
